import { useState } from "react";
import { galleryItems } from "@/mocks/galleryItems";

export default function GallerySection() {
  const [selected, setSelected] = useState<number | null>(null);

  return (
    <section id="galeri" className="py-20 md:py-28 bg-[#faf9f7]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 text-[#e8734a] text-sm font-semibold mb-4">
            <i className="ri-image-line"></i>
            Galeri
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-[#1a3a4a] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            Mutfağımızdan Kareler
          </h2>
          <p className="text-gray-500 text-base max-w-xl mx-auto">
            Taze balıklarımız, sıcak atmosferimiz ve güzel anlarımızdan bir kesit
          </p>
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {/* Large item */}
          <div
            className="lg:col-span-2 relative rounded-2xl overflow-hidden h-64 md:h-80 cursor-pointer group"
            onClick={() => setSelected(galleryItems[0].id)}
          >
            <img
              src={galleryItems[0].image}
              alt={galleryItems[0].title}
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            <div className="absolute bottom-4 left-4 text-white font-semibold text-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              {galleryItems[0].title}
            </div>
          </div>

          {/* Medium item */}
          <div
            className="relative rounded-2xl overflow-hidden h-64 md:h-80 cursor-pointer group"
            onClick={() => setSelected(galleryItems[1].id)}
          >
            <img
              src={galleryItems[1].image}
              alt={galleryItems[1].title}
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            <div className="absolute bottom-4 left-4 text-white font-semibold text-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              {galleryItems[1].title}
            </div>
          </div>

          {/* Row 2 */}
          {galleryItems.slice(2, 5).map((item) => (
            <div
              key={item.id}
              className="relative rounded-2xl overflow-hidden h-52 cursor-pointer group"
              onClick={() => setSelected(item.id)}
            >
              <img
                src={item.image}
                alt={item.title}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              <div className="absolute bottom-4 left-4 text-white font-semibold text-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                {item.title}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {selected !== null && (
        <div
          className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4"
          onClick={() => setSelected(null)}
        >
          <div className="relative max-w-4xl w-full" onClick={(e) => e.stopPropagation()}>
            <button
              className="absolute -top-10 right-0 text-white w-8 h-8 flex items-center justify-center cursor-pointer"
              onClick={() => setSelected(null)}
            >
              <i className="ri-close-line text-2xl"></i>
            </button>
            {galleryItems.find((g) => g.id === selected) && (
              <img
                src={galleryItems.find((g) => g.id === selected)!.image}
                alt=""
                className="w-full rounded-xl object-cover max-h-[80vh]"
              />
            )}
          </div>
        </div>
      )}
    </section>
  );
}
